import { useCallback, useEffect, useState } from 'react';

import { PLANS_VISIBLE } from '../config/plans';
import { getMyPlan } from '../services/plans';

/**
 * The signed-in account's own plan, its limits and usage, for the Plan
 * section in Account settings (`GET /api/users/me/plan`; KPR-1095).
 *
 * Dark until billing ships: while `PLANS_VISIBLE` (config/plans.js) is off it
 * asks NOTHING and answers `{ enabled: false }`, so no request about plans
 * leaves the page. Asked once per mount; `retry()` asks again.
 *
 *   { enabled, plan, loading, error, retry }
 *
 * A collection's limits are not here: they ride on the collection read as
 * `entitlements` (no usage, no plan name), for whoever reads it.
 */
export default function usePlan({ enabled = PLANS_VISIBLE } = {}) {
	const [state, setState] = useState({ plan: null, loading: !!enabled, error: null });
	const [attempt, setAttempt] = useState(0);
	useEffect(() => {
		if (!enabled) return undefined;
		let live = true;
		setState(prev => ({ ...prev, loading: true, error: null }));
		getMyPlan()
			.then((plan) => { if (live) setState({ plan, loading: false, error: null }); })
			.catch((error) => { if (live) setState(prev => ({ ...prev, loading: false, error })); });
		return () => { live = false; };
	}, [enabled, attempt]);
	const retry = useCallback(() => setAttempt(n => n + 1), []);
	return { enabled: !!enabled, ...state, retry };
}
